import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-list-bulk-checkbox',
  templateUrl: './list-bulk-checkbox.component.html',
  styleUrls: ['./list-bulk-checkbox.component.css'],
})
export class ListBulkCheckboxComponent implements OnInit {
  @Input() page: number;
  @Input() length: number;
  @Input() selectedOnPage: any;
  @Output() check = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onSelectAll(): void {
    this.check.emit();
  }
}
